import { render, staticRenderFns } from "./StoryTemplate.vue?vue&type=template&id=1dab2600&scoped=true&"
import script from "./StoryTemplate.vue?vue&type=script&lang=js&"
export * from "./StoryTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab2600",
  null
  
)

export default component.exports